import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import StatsCard from '../../components/StatsCard';
import Loader from '../../global/loader';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import apiRequest from '../../utils/apiRequest';
import toast from 'react-hot-toast';

interface TierType {
  id: string;
  name: string;
  count: string;
}

interface DashboardStatsType {
  totalOrderPlaced: string;
  salesInfluenced: string;
  redeemer: string;
}

const Dashboard = () => {
  const [loader, setLoader] = useState(false);
  const [dashboardData, setDashboardData] = useState<TierType[]>([]);
  const [dashboardStats, setDashboardStats] =
    useState<DashboardStatsType | null>();

  const getDashboardStats = async () => {
    const res = await apiRequest('getDashboardStats');

    if (res.error) {
      setDashboardStats(null);
    } else {
      setDashboardStats(res.data);
    }
  };

  const getTierCount = async () => {
    setLoader(true);

    const res = await apiRequest('getDashboard');
    setLoader(false);

    if (res.error) {
      toast.error('Failed to get dashboard');
    } else {
      setDashboardData(res.data);
    }
  };

  const getDashboardData = () => {
    getDashboardStats();
    getTierCount();
  };

  useEffect(() => {
    getDashboardData();
  }, []);

  return (
    <>
      {loader && <Loader showHide={loader} />}
      {!loader && (
        <div className='px-5'>
          <Header title='Dashboard' />

          <div className='flex flex-wrap'>
            {dashboardStats &&
              (Object.keys(dashboardStats) as (keyof DashboardStatsType)[]).map(
                (val) => (
                  <StatsCard
                    key={val}
                    version='solid'
                    header={val}
                    value={
                      val === 'salesInfluenced'
                        ? ` ₹ ${dashboardStats[val]}`
                        : dashboardStats[val]
                    }
                  />
                )
              )}
            {dashboardData &&
              dashboardData.map((cardData) => (
                <StatsCard
                  key={cardData.id}
                  version='solid'
                  header={`${cardData.name} Tier`}
                  value={cardData.count}
                />
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default Dashboard;
